import { useCallback, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_FULL, Loader } from "@/components/common";
import FreeDashboard from "./FreeDashboard";
import FreeIdea from "./FreeIdea";
import Unlock from "./Unlock";

const PAGES = { "/": FreeDashboard, "/free-idea": FreeIdea, "/unlock": Unlock };

export default function FreeArea() {
  const { logout, refresh, user } = useAuth();
  const { pathname } = useLocation();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/free/home").then((r) => setData(r.data)), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { if (data?.full_access) refresh(); }, [data, refresh]);
  const Page = PAGES[pathname];
  if (!Page) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-[#F6FAFA]" data-testid="free-area">
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-[#E1ECEF] pt-safe">
        <div className="max-w-3xl mx-auto px-5 h-14 flex items-center justify-between">
          <img src={LOGO_FULL} alt="Sidebizz" className="h-7" />
          <button onClick={logout} className="text-sm font-semibold text-[#5C6B73] inline-flex items-center gap-1.5 min-h-[44px]" data-testid="free-logout-btn"><LogOut className="h-4 w-4" />{user?.language === "fr" ? "Se déconnecter" : "Log out"}</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-6 pb-safe">{data ? <Page data={data} reload={load} /> : <Loader />}</main>
    </div>
  );
}
